import { render, staticRenderFns } from "./SuggestAnalysisSampleBoxes.vue?vue&type=template&id=50d0e642&scoped=true"
import script from "./SuggestAnalysisSampleBoxes.vue?vue&type=script&lang=js"
export * from "./SuggestAnalysisSampleBoxes.vue?vue&type=script&lang=js"
import style0 from "./SuggestAnalysisSampleBoxes.vue?vue&type=style&index=0&id=50d0e642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d0e642",
  null
  
)

export default component.exports